<template>
  <article class="quiz-body" :class="{ yellowWarning: Number(item?.status) === 1 }">
    <div class="quiz-title">
      <span class="material-icons-outlined color-quiz-icon">info</span>
      <span class="title">{{ item?.title }}</span>
    </div>
    <div class="p-2">
      <p class="text">{{ item?.text || item?.descripton }}</p>
      <RouterLink :to="`/quiz/${item?.id}`" class="color-quiz">
        {{ Number(item?.status) === 1 ? t('surveyContinue') : t('surveyStart') }}
      </RouterLink>
    </div>
  </article>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  item: {
    type: Object,
    default: () => ({})
  }
});

const { t } = useI18n();
</script>

<style scoped>
.quiz-title {
  display: flex;
  background: #1890ff;
  padding: 8px;
  border-radius: 4px 4px 0 0;
  color: #fff;
  min-height: 44px;
  align-items: center;
}

.quiz-body {
  border: 1px solid #e0e0e0;
  background: #e6f7ff;
  border-color: rgba(145, 213, 255, 0.6);
  border-radius: 4px;
}

.yellowWarning {
  border: 1px solid rgba(248, 199, 62, 0.6);
  background: #fff7e0;
}

.yellowWarning .quiz-title {
  background: #f7b422;
}

.title {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  margin-left: 8px;
}

.text {
  font-size: 14px;
  line-height: 22px;
  text-align: justify;
  color: #000;
  margin-bottom: 4px;
}

.color-quiz {
  color: #1890ff;
}
</style>
